import {none, Opt} from 'ts-opt';

import {ModuleGuideUrls} from 'api/gen/ModuleGuideUrls';

import {LoadingItemId} from '../types';

/** Shared layout state for loading indicators, tutorials, and cookie-related shell behavior. */
export interface LayoutState {
    /** Table and screen loading identifiers currently in progress. */
    loadingItems: Array<LoadingItemId>;
    /** Tutorial URLs for the currently active module. */
    commonTutorialsUrls: Opt<ModuleGuideUrls>;
    /** Whether the statistical cookies are enabled in the shell. */
    statisticalCookieEnabled: boolean;
}

/**
 * Default shared layout state used when the shell store is initialized.
 *
 * @returns Default layout state snapshot.
 */
export const initialLayoutState: LayoutState = {
    loadingItems: [],
    commonTutorialsUrls: none,
    statisticalCookieEnabled: false,
};
